export default __webpack_public_path__ + "media/images/agent-68135659b9c62b9f7167af7cb4828b1e.jpg";